import {FC} from 'react';
import {Dictionary, size} from 'lodash';
import {observer} from 'mobx-react';
import {Field} from 'apstra-ui-common';
import cx from 'classnames';

import {Button} from 'semantic-ui-react';

import PortChannelIdRange from './PortChannelIdRange';
import PortsCount from './PortsCount';
import NumberInput from './NumberInput';

import Node from '../store/Node';
import LinksGroup from '../store/LinksGroup';

import './PeerLinkForm.less';

type PeerLinkFormProps = {
  title: string;
  portsSpeeds: Dictionary<number>;
  node: Node;
  link: LinksGroup;
  required?: boolean;
  isExt?: boolean;
  error: boolean;
  trackChange: (property: string, value: unknown, target: Node | LinksGroup) => void;
}

const PeerLinkForm: FC<PeerLinkFormProps> = ({
  title, portsSpeeds, node, link, required, isExt, error, trackChange
}) => {
  const {count = 0, speedString} = link;
  const portsBySpeed = size(portsSpeeds) ? {...portsSpeeds} : {[speedString]: 0};

  const portsAvailable = portsSpeeds?.[speedString] ?? 0;
  const maxCount = portsAvailable + count;

  const noSpeed = !speedString || (!count && !maxCount);

  const deleteLinks = () => {
    trackChange('count', 0, link);
    trackChange('speed', undefined, link);
  };

  return (
    <div className='re-peer-linker'>
      <div className='re-peer-linker-title'>
        <h6 className={cx({required})}>{title}</h6>
      </div>
      <div className='re-peer-linker-data'>
        <div className='re-peer-links'>
          <div className='re-port-and-count'>
            <div className='re-inputs'>
              <PortsCount
                portsBySpeed={portsBySpeed}
                selectedSpeed={noSpeed ? undefined : speedString}
                onClick={(speed) => {
                  trackChange('speed', speed, link);
                  trackChange('count', 1, link);
                }}
                error={required && noSpeed}
                showEmpty
                usedCount={count}
              />
              <Field label='Count' disabled={noSpeed} required={required} className='count'>
                <NumberInput
                  type='number'
                  size='small'
                  fluid
                  value={count}
                  min={0}
                  max={maxCount}
                  onChange={(event, {value}) => trackChange('count', value, link)}
                  error={required && !count}
                />
              </Field>
            </div>
          </div>
        </div>
        <div className='re-port-channels'>
          <div className='re-inputs'>
            {
              <PortChannelIdRange
                minValue={node.portChannelId}
                maxValue={node.portChannelIdExt}
                disabled={!count}
                showOnlyMax={isExt}
                error={!!error}
                onChange={(minValue, maxValue) =>
                  trackChange(isExt ? 'portChannelIdExt' : 'portChannelId', isExt ? maxValue : minValue, node)
                }
                node={node}
              />
            }
          </div>
        </div>
        <div>
          <Button icon='trash' size='tiny' onClick={deleteLinks} disabled={!count} />
        </div>
      </div>
    </div>
  );
};

export default observer(PeerLinkForm);
